import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-catalog',
  templateUrl: './catalog.component.html',
  styleUrls: ['./catalog.component.css']
})
export class CatalogComponent implements OnInit {

  public form: any;
  public error:string;
  public finished: boolean;
  public iframeURL: SafeUrl;
  public loading: boolean;
  

  public submit(form) {
    // if (!(form.name && form.email && form.phone && form.referral && form.inquiry)) {
    //   this.error = "Please fill out all fields.";
    //     setTimeout(() => {
    //       this.error = null;
    //     }, 1000);
    //   return;
    // }
    // if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(form.email))) {
    //   this.error = "Please enter a valid email address.";
    //     setTimeout(() => {
    //       this.error = null;
    //     }, 1000);
    //   return;
    // }
    // if (form.inquiry && (form.inquiry === 'dealer' || form.inquiry === 'builder') && !(form.company && form.state && form.position)) {
    //   this.error = "Please tell us about you and your company";
    //     setTimeout(() => {
    //       this.error = null;
    //     }, 1000);
    //   return;
    // }
    // this.connectService.submit(form);
    this.submitAuth(form);
    console.log("FORM: ", form);
    this.finished = true;


  }

  public submitAuth (form) {
    // console.log(form);
    if (!(form.username && form.email && form.password)) {
      this.error = "Please fill out all fields.";
        setTimeout(() => {
          this.error = null;
        }, 3000);
      return;
    }
    if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(form.email))) {
      this.error = "Please enter a valid email address.";
        setTimeout(() => {
          this.error = null;
        }, 3000);
      return;
    }

    this.loading = true;
    return this.http.post('/login/password', form)
      .subscribe(res => {
        console.log("submit: ", res);
          // return true;
          this.getCatalogURL();
        }, (err) => {
          console.error("submit: ", err);
          this.loading = false;
        }
      );
  }

  public getCatalogURL () {
    this.loading = true;
    this.http.get<any>('/catalog-url').subscribe(catalogRes => {
      console.log("catalogRes: ", catalogRes);
      this.loading = false;
      this.iframeURL =  this.sanitizer.bypassSecurityTrustResourceUrl(catalogRes.url);
      return true;
    },
      (err)=>{
        this.loading = false;
        console.error("catalogErr: ", err);
      });
  }

  constructor(private http: HttpClient, private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.form = {};
    this.loading = true;
    this.getCatalogURL();

  }


}



// WEBPACK FOOTER //
// /tmp/build_0264da94/src/app/catalog/catalog.component.ts